import endpoints, { formatEndpoint } from '../endpoints';
import { RestManagerWithoutBaseUrl } from '../RestManager';
class GatewayManagementApi {
    static getGatewayList(organizationID) {
        const endpoint = formatEndpoint(endpoints.gatewayManagement.getGatewayList);
        return RestManagerWithoutBaseUrl.post(endpoint, organizationID);
    }

    static getGatewayType() {
        const endpoint = formatEndpoint(endpoints.gatewayManagement.getGatewayType);
        return RestManagerWithoutBaseUrl.get(endpoint);
    }

    static getGatewayDetails(id, isSyntheticGateway) {
        const endpoint = formatEndpoint(endpoints.gatewayManagement.getGatewayDetails);
        return RestManagerWithoutBaseUrl.post(endpoint, { isSyntheticGateway, id });
    }

    static getGatewayConnectAssets(id, isSyntheticGateway) {
        const endpoint = formatEndpoint(endpoints.gatewayManagement.getGatewayConnectedAssets);
        return RestManagerWithoutBaseUrl.post(endpoint, { id, isSyntheticGateway });
    }

    static deleteGatewayAsset(assetId) {
        const endpoint = formatEndpoint(endpoints.gatewayManagement.deleteGatewayAsset, { assetId });
        return RestManagerWithoutBaseUrl.delete(endpoint);
    }

    static refreshGateway(gatewayID) {
        const endpoint = formatEndpoint(endpoints.gatewayManagement.refreshGateway, { gatewayID });
        return RestManagerWithoutBaseUrl.post(endpoint, { gatewayID });
    }

    static updateFirmware(gatewayID) {
        const endpoint = formatEndpoint(endpoints.gatewayManagement.updateFirmware, { gatewayID });
        return RestManagerWithoutBaseUrl.post(endpoint, { gatewayID });
    }

    static activateDeactivateGateway(gatewayID, datacollectionUnitId, isActivate) {
        const endpoint = formatEndpoint(endpoints.gatewayManagement.activateDeactivateGateway, { gatewayID });
        return RestManagerWithoutBaseUrl.post(endpoint, { datacollectionUnitId, isActivate });
    }

    static gatewayRename(gatewayId, name) {
        const endpoint = formatEndpoint(endpoints.gatewayManagement.gatewayRename, { gatewayId });
        return RestManagerWithoutBaseUrl.put(endpoint, { gatewayId, name });
    }

    static deleteGateway(gatewayId) {
        const endpoint = formatEndpoint(endpoints.gatewayManagement.deleteGateway, { gatewayId });
        return RestManagerWithoutBaseUrl.delete(endpoint);
    }

    static exportMessageArchive(payload) {
        const endpoint = formatEndpoint(endpoints.gatewayManagement.exportMessageArchive);
        return RestManagerWithoutBaseUrl.post(endpoint, payload);
    }

    static disconnectGatewayAsset(assetId, dataCollectionUnitId) {
        const endpoint = formatEndpoint(endpoints.gatewayManagement.disconnectGatewayAsset, { assetId });
        return RestManagerWithoutBaseUrl.post(endpoint, { assetId, dataCollectionUnitId });
    }

    static getParameterBackup(assetId, formatType) {
        const endpoint = formatEndpoint(endpoints.gatewayManagement.parameterBackup, { assetId, formatType });
        return RestManagerWithoutBaseUrl.post(endpoint);
    }

    static downloadInstallationReport(gatewayId, fileType) {
        const endpoint = formatEndpoint(endpoints.gatewayManagement.downloadInstallationReport, { gatewayId, fileType });
        return RestManagerWithoutBaseUrl.get(endpoint);
    }

    static downloadDiagnosticReport(dcuId) {
        const endpoint = formatEndpoint(endpoints.gatewayManagement.downloadDiagnosticReport, { dcuId });
        return RestManagerWithoutBaseUrl.get(endpoint);
    }

    static switchAssetToAnotherGateway(sourceAssetId, targetGatewayId, targetAssetId, isSwitchEgwToAnotherGateway) {
        const endpoint = formatEndpoint(endpoints.gatewayManagement.switchAssetToAnotherGateway);
        return RestManagerWithoutBaseUrl.post(endpoint, { sourceAssetId, targetGatewayId, targetAssetId, isSwitchEgwToAnotherGateway });
    }

    static validateSwitchGatewayAsset(sourceAssetId, targetGatewayId, targetAssetId, isSwitchEgwToAnotherGateway) {
        const endpoint = formatEndpoint(endpoints.gatewayManagement.validateSwitchGatewayAsset, { assetId: sourceAssetId });
        return RestManagerWithoutBaseUrl.post(endpoint, { sourceAssetId, targetGatewayId, targetAssetId, isSwitchEgwToAnotherGateway });
    }

    static getGatewayAssetsList(gatewaySerialNumber) {
        const endpoint = formatEndpoint(endpoints.gatewayManagement.getGatewayAssetsList, { gatewaySerialNumber });
        return RestManagerWithoutBaseUrl.get(endpoint);
    }

    static moveGatewayAsset(driveSerialnumber, gatewaySerialNumber, driveAddress) {
        const endpoint = formatEndpoint(endpoints.gatewayManagement.moveGatewayAsset);
        return RestManagerWithoutBaseUrl.post(endpoint, { driveSerialnumber, gatewaySerialNumber, driveAddress });
    }

    static validateGatewayAsset(driveSerialnumber, gatewaySerialNumber, driveAddress) {
        const endpoint = formatEndpoint(endpoints.gatewayManagement.validateGatewayAsset);
        return RestManagerWithoutBaseUrl.post(endpoint, { driveSerialnumber, gatewaySerialNumber, driveAddress });
    }

    static getDriveApplications() {
        const endpoint = formatEndpoint(endpoints.gatewayManagement.getDriveApplications);
        return RestManagerWithoutBaseUrl.get(endpoint);
    }

    static updateAssetNameAndDriveApplication(id, assetId, assetName, applicationId) {
        const endpoint = formatEndpoint(endpoints.gatewayManagement.updateAssetNameAndDriveApplication, { id });
        return RestManagerWithoutBaseUrl.put(endpoint, { assetId, assetName, applicationId });
    }

    static lastCommandStatusActivateRemoteConnection(gatewayId, requestType) {
        const endpoint = formatEndpoint(endpoints.gatewayManagement.lastCommandStatusActivateRemoteConnection, { gatewayId, requestType });
        return RestManagerWithoutBaseUrl.post(endpoint);
    }

    static rebootGateway(gatewayId) {
        const endpoint = formatEndpoint(endpoints.gatewayManagement.rebootGateway, { gatewayId });
        return RestManagerWithoutBaseUrl.post(endpoint, { gatewayId });
    }

    static disconnectEnvironmentSensor(gatewayId) {
        const endpoint = formatEndpoint(endpoints.gatewayManagement.disconnectEnvironmentSensor, { gatewayId });
        return RestManagerWithoutBaseUrl.post(endpoint, { gatewayId });
    }

    static gatewayEvents(params) {
        const endpoint = formatEndpoint(endpoints.gatewayManagement.gatewayEvents);
        return RestManagerWithoutBaseUrl.post(endpoint, params);
    }

    static gatewayEventsAttachments(globalEventId, eventSource) {
        const endpoint = formatEndpoint(endpoints.gatewayManagement.gatewayEventsAttachments);
        return RestManagerWithoutBaseUrl.post(endpoint, { globalEventId, eventSource });
    }

    static getGatewayConnectionHistory(id) {
        const endpoint = formatEndpoint(endpoints.gatewayManagement.connectionHistoryGateway, { id });
        return RestManagerWithoutBaseUrl.get(endpoint);
    }

    static getAssetConnectionHistory(assetId) {
        const endpoint = formatEndpoint(endpoints.gatewayManagement.connectionHistoryAsset, { assetId });
        return RestManagerWithoutBaseUrl.get(endpoint);
    }

    static getAssetConnectionStatusHistory(requestPayload) {
        const endpoint = formatEndpoint(endpoints.gatewayManagement.getAssetConnectionHistory);
        return RestManagerWithoutBaseUrl.post(endpoint, requestPayload);
    }

    static downloadLogLimitCheck(requestPayload) {
        const endpoint = formatEndpoint(endpoints.gatewayManagement.downloadLogLimitCheck);
        return RestManagerWithoutBaseUrl.post(endpoint, requestPayload);
    }

    static downloadLogs(requestPayload) {
        const endpoint = formatEndpoint(endpoints.gatewayManagement.downloadLogs);
        return RestManagerWithoutBaseUrl.postBlob(endpoint, requestPayload);
    }
}
export default GatewayManagementApi;
